import { useQuery } from '@tanstack/react-query';
import { QUERY_KEY_MAP } from 'src/constants/query-key';

import { getVideoUrlPromise } from 'src/utils/api';

export const useGetVideoUrl = (taskId?: string) => {
  const { data, isLoading } = useQuery({
    queryKey: [QUERY_KEY_MAP.useGetVideoUrl, taskId],
    queryFn: () => getVideoUrlPromise(taskId as string),
    enabled: !!taskId,
  });

  return {
    videoUrl: data,
    isLoading,
  };
};
